import { Configuration, PublicClientApplication } from "@azure/msal-browser";

import { msEntraClientId } from "../helpers/env.helpers";

const msalConfig: Configuration = {
  auth: {
    clientId: msEntraClientId(),
  },
};

export const msalPublicClientApplication = new PublicClientApplication(
  msalConfig,
);
